export default __webpack_public_path__ + "static/media/abuelajovenedit.a1ee3114.jpg";